import { render } from "./SmileIcon.vue?vue&type=template&id=3832b63e&ts=true"
import script from "./SmileIcon.vue?vue&type=script&lang=ts"
export * from "./SmileIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__